export default __webpack_public_path__ + "static/media/record-store-closed.56d2a1a0.png";